import classNames from 'classnames/bind'
import moment from 'moment-timezone'

import MonthSelector from './month-selector'
import styles from './month-switcher.module.scss';
import { useMemo } from 'react';


const cx = classNames.bind(styles);

type Props = {
  className?: string
  monthDate: string
  dateFormat: string
  hideYear?: boolean
  disableMonthModal?: boolean
  disableMonthSwitcherByStatus?: boolean
  onPrev?: () => void
  onNext?: () => void
  onMonth: (m: number) => void
  onYear: (y: number) => void
  dateDisabledStatus?: (dayFormatted: string, format: string, unit?: string) => boolean
}

const MonthSwitcher = ({
  className,
  monthDate,
  dateFormat,
  hideYear,
  disableMonthModal,
  onPrev,
  onNext,
  onMonth,
  onYear,
  dateDisabledStatus,
  disableMonthSwitcherByStatus
}: Props) => {
  const currentMoment = moment(monthDate, dateFormat)

  const prevMoment = useMemo(() => currentMoment.clone().subtract(1, 'month'), [currentMoment])
  const nextMoment = useMemo(() => currentMoment.clone().add(1, 'month'), [currentMoment])

  const isPrevDisabled = disableMonthSwitcherByStatus && dateDisabledStatus
    ? dateDisabledStatus(prevMoment.format(dateFormat), dateFormat, 'months')
    : false

  const isNextDisabled = disableMonthSwitcherByStatus && dateDisabledStatus
    ? dateDisabledStatus(nextMoment.format(dateFormat), dateFormat, 'months')
    : false

  const title = (
    hideYear
      ? moment(monthDate, dateFormat).format('MMMM')
      : moment(monthDate, dateFormat).format('MMMM YYYY')
  )

  return (
    <div className={cx(styles.root, className)}>
      {onPrev
        && <button
          type="button"
          className={cx(styles.button, styles.button__prev, 'doNotCloseDropdown', { disabled: isPrevDisabled })}
          onClick={onPrev}
          disabled={isPrevDisabled}
        >
          <span className="visuallyHidden">
            {'Предыдущий месяц'}
          </span>
        </button>}

      {hideYear || disableMonthModal
        ? <div className={styles.month}>{title}</div>
        : <MonthSelector
          monthDate={monthDate}
          dateFormat={dateFormat}
          onMonth={onMonth}
          onYear={onYear}
          dateDisabledStatus={dateDisabledStatus}
        >
          {toggleSelector => (
            <button
              type="button"
              className={cx(styles.button, styles.button__monthYear, 'doNotCloseDropdown')}
              onClick={toggleSelector}
            >
              <div className={styles.monthYear}>{title}</div>
            </button>)}
        </MonthSelector>}

      {onNext
        && <button
          type="button"
          className={cx(styles.button, styles.button__next, 'doNotCloseDropdown', { disabled: isNextDisabled })}
          onClick={onNext}
          disabled={isNextDisabled}
        >
          <span className="visuallyHidden">
            {'Следующий месяц'}
          </span>
        </button>}
    </div>
  )
}

export default MonthSwitcher
